import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { getUserRole } from '../helpers/tokenService';

const AuthGuard = ({ children, allowedRoles }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const userRole = getUserRole();

  if (!isAuthenticated) {
    // Redirect to login page and keep the current URL in location state
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // If the user's role is not allowed, redirect to their main dashboard
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthGuard;
